import React, { useReducer } from 'react'
import axios from 'axios'
import InfoReducer from './infoReducer'
import InfoContext from './infoContext'
import { GET_EDUCATION, GET_INTRO, GET_SKILLS, GET_SOCIAL, INFO_ERROR, GET_JOURNEY, GET_PROGRESS_BARS } from '../types'

const InfoState = props => {

    const initialState = {
        education: [],
        intro: [],
        social: [],
        skills: [],
        journey: [],
        progressBars: [],
        loading: true
    }

    const [state, dispatch] = useReducer(InfoReducer, initialState)

    const getAllJourneys = async () => {
        try {
            const res = await axios(`${process.env.REACT_APP_PROXY}/api/journey`);
            dispatch({
                type: GET_JOURNEY,
                payload: res.data.data
            })
        } catch (err) {
            dispatch({
                type: INFO_ERROR
            })
        }
    }
    
    const getAllIntros = async () => {
        try {
            const res = await axios(`${process.env.REACT_APP_PROXY}/api/intro`);
            dispatch({
                type: GET_INTRO,
                payload: res.data.data
            })
        } catch (err) {
            dispatch({
                type: INFO_ERROR
            })
        }
    }
    const getAllSocials = async () => {
        try {
            const res = await axios(`${process.env.REACT_APP_PROXY}/api/social`);
            dispatch({
                type: GET_SOCIAL,
                payload: res.data.data
            })
        } catch (err) {
            dispatch({
                type: INFO_ERROR
            })
        }
    }
    const getAllSkills = async () => {
        try {
            const res = await axios(`${process.env.REACT_APP_PROXY}/api/skills`);
            dispatch({
                type: GET_SKILLS,
                payload: res.data.data
            })
        } catch (err) {
            dispatch({
                type: INFO_ERROR
            })
        }
    }

    const getAllProgressBars = async () => {
        try {
            const res = await axios(`${process.env.REACT_APP_PROXY}/api/progressBars`);
            dispatch({
                type: GET_PROGRESS_BARS,
                payload: res.data.data
            })
        } catch (err) {
            dispatch({
                type: INFO_ERROR
            })
        }
    }

    const getAllEducations = async () => {
        try {
            const res = await axios(`${process.env.REACT_APP_PROXY}/api/education`);
            dispatch({
                type: GET_EDUCATION,
                payload: res.data.data
            })
        } catch (err) {
            dispatch({
                type: INFO_ERROR
            })
        }

    }

    return (
        <InfoContext.Provider
        value={{
            education: state.education,
            intro: state.intro,
            social: state.social,
            skills: state.skills,
            loading: state.loading,
            journey: state.journey,
            progressBars: state.progressBars,
            getAllEducations,
            getAllIntros,
            getAllSkills,
            getAllSocials,
            getAllJourneys,
            getAllProgressBars
        }}
        >
            { props.children }
        </InfoContext.Provider>
    )
}


export default InfoState
